import { SET_SCENARIOS } from "./types";

const state = {
  scenarios: []
};

const mutations = {
  [SET_SCENARIOS](state, scenarios) {
    state.scenarios = scenarios;
  },
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
